/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const positionRight = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M19 5.5h-8V4h8v1.5ZM19 20h-8v-1.5h8V20ZM5 9h14v6H5V9Z" />
	</SVG>
);

export default positionRight;
